import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import TimeTriggerViewMode from '@nile/banyan/src/Components/TimeTriggerViewMode';
import {
  Icon,
  T2,
  Tag,
  DeleteModal,
  AccessControl,
  WithCard,
  BackgroundIcon,
  getTranslatedText
} from '@nile/components';
import {
  Button,
  Card,
  Heading,
  Link,
  ResourceItem,
  ResourceList,
  TextStyle,
  ButtonGroup,
  Badge
} from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import { cloneDeep, isEqual } from 'lodash';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

class TimeTriggerCascade extends Component {
  constructor(props) {
    super(props);
    const { rules } = props;
    this.state = {
      inputValue: '',
      value: [],
      allRules: props.rules,
      selectedTimeTrigger: rules.length > 0 ? rules[0] : {},
      selectedItems: rules.length > 0 ? [props.rules[0].id] : []
    };
  }

  componentDidMount() {
    if (this.props.rules.length > 0) {
      this.renderSubItem(this.props.rules[0]);
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.rules, state.allRules)) {
      return {
        ...state,
        allRules: props.rules,
        selectedTimeTrigger: props.rules.length > 0 ? props.rules[0] : {},
        selectedItems: props.rules.length > 0 ? [props.rules[0].id] : []
      };
    }
    return null;
  }

  renderSubItem = (item) => {
    this.setState({ selectedTimeTrigger: item });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
    }
  };

  handleTimeTriggerChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  deleteTimeTrigger = (id) => {
    this.props.deleteTrigger({
      variables: { id, automationRuleType: 'TIME_TRIGGERS' }
    });
  };

  handleEdit = (mod) => {
    const { tabContext } = this.props;
    tabContext.openTab({
      module: 'ONBOARD',
      url: mod.url
    });
  };

  render() {
    const { selectedTimeTrigger, selectedItems } = this.state;
    const { rules, intl } = this.props;

    const processedAllItems = processData(rules, 'id');

    return (
      <div className="full-height">
        <div className="fx ch-20">
          <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width full-height fx col">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleTimeTriggerChange}
                />
              </div>
              <div className="cascade-list ch-50">
                <ResourceList
                  items={rules}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item) => {
                    const { id, name } = item;
                    return (
                      <ResourceItem
                        id={id}
                        accessibilityLabel={`View details for ${name}`}
                      >
                        <div
                          className="fw fh"
                          onClick={this.renderSubItem.bind(this, item)}
                        >
                          <TextStyle variation="strong">{name} </TextStyle>
                        </div>
                        {item.uioptions && item.uioptions.length > 0 ? (
                          <div className="iconHolder">
                            <SVGIcon name="ArrowRight" />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </ResourceItem>
                    );
                  }}
                />
              </div>
            </div>
          </div>

          {selectedTimeTrigger && (
            <div className="fx p2040 scroll w70">
              <div className="full-width">
                <div className="Main-Heading flex center h90px">
                  <div className="fx2 self-start">
                    <div className="flex actr g10">
                      <Heading element="h2">{selectedTimeTrigger.name}</Heading>
                      <Badge
                        status={selectedTimeTrigger.active ? 'success' : ''}
                      >
                        {selectedTimeTrigger.active
                          ? getTranslatedText(
                              intl,
                              'admin.timeTriggers.status.active'
                            )
                          : getTranslatedText(
                              intl,
                              'admin.timeTriggers.status.inActive'
                            )}
                      </Badge>
                    </div>
                    <TextStyle variation="subdued">
                      {selectedTimeTrigger.description}
                    </TextStyle>
                  </div>
                  <div
                    className="fx jend self-start Time-Triggers-Action"
                    data-qa="timeTriggerEdit"
                  >
                    <ButtonGroup>
                      <AccessControl
                        roleToCheck="timeTriggers.delete"
                        render={
                          <DeleteModal
                            id="deleteSLA"
                            description={getTranslatedText(
                              intl,
                              'admin.timeTrigger.deleteMessage'
                            )}
                            handleDeleteConfirmation={() =>
                              this.deleteTimeTrigger(selectedTimeTrigger.id)
                            }
                            title={getTranslatedText(
                              intl,
                              'admin.timeTrigger.deleteTitle'
                            )}
                          />
                        }
                      />
                      <AccessControl
                        roleToCheck="timeTriggers.edit"
                        render={
                          <Button
                            // size="slim"
                            // url={
                            //   '#/onboard/timetrigger/' +
                            //   selectedTimeTrigger.id +
                            //   '/edit'
                            // }
                            onClick={this.handleEdit.bind(this, {
                              url: `/onboard/timetrigger/${selectedTimeTrigger.id}/edit`
                            })}
                            icon={
                              <div className="fx center">
                                <SVGIcon name="Edit" />
                              </div>
                            }
                          />
                        }
                      />
                    </ButtonGroup>
                  </div>
                </div>
                <TimeTriggerViewMode timeTrigger={selectedTimeTrigger} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(TimeTriggerCascade);
